/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TaskConfigResponse { 
    task_sub_type?: string;
    task_type?: string;
    tenant_ui?: boolean;
}

